import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription, interval } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { VisitTrackerService } from './core/services/visit-tracker.service';
import { SiteConfigService } from './core/services/site-config.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  showMaintenanceModal = false;
  maintenanceMessage = '';
  private maintenanceSub!: Subscription;

  constructor(
    private router: Router,
    private visitTracker: VisitTrackerService,
    private http: HttpClient,
    private siteConfigService: SiteConfigService,
  ) { }

  ngOnInit(): void {
    this.siteConfigService.getSiteConfig().subscribe();
    this.visitTracker.start();

    this.checkMaintenanceTime();
    // Periodically check every 30 seconds
    this.maintenanceSub = interval(30000).subscribe(() => {
      this.checkMaintenanceTime();
    });

    // Listen to route changes to update the maintenance message based on page context
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkMaintenanceTime();
    });
  }

  ngOnDestroy(): void {
    if (this.maintenanceSub) {
      this.maintenanceSub.unsubscribe();
    }
  }

  private checkMaintenanceTime(): void {
    const loggedInUser = localStorage.getItem('loggedInUser')
      ? JSON.parse(localStorage.getItem('loggedInUser')!)
      : null;

    const currentUrl = this.router.url || window.location.pathname;

    // Support role and Login page are exempt from maintenance block
    if (loggedInUser?.roleName === 'SUPPORT' || currentUrl.includes('/login')) {
      this.showMaintenanceModal = false;
      return;
    }

    this.http.get<{ enabled: boolean | null }>(`${environment.apiUrl}/maintenance-status`).subscribe({
      next: (res) => {
        let isMaintenance = false;

        if (res.enabled === true) {
          isMaintenance = true;
        } else {
          isMaintenance = false;
        }

        if (isMaintenance) {
          this.showMaintenanceModal = true;
          if (currentUrl.includes('/register')) {
            this.maintenanceMessage = 'The registration portal is under scheduled maintenance. Please try registering after some time.';
          } else {
            this.maintenanceMessage = 'The portal is under scheduled maintenance. We apologize for any inconvenience caused.';
          }
        } else {
          this.showMaintenanceModal = false;
        }
      },
      error: () => {
        // Fallback to local time check if backend API fails
        const now = new Date();
        const hours = now.getHours();
        if (hours >= 0 && hours < 6) {
          this.showMaintenanceModal = true;
          if (currentUrl.includes('/register')) {
            this.maintenanceMessage = 'The registration portal is under scheduled maintenance. Please try registering after some time.';
          } else {
            this.maintenanceMessage = 'The portal is under scheduled maintenance. We apologize for any inconvenience caused.';
          }
        } else {
          this.showMaintenanceModal = false;
        }
      }
    });
  }
}
